export default "__VITE_ASSET__BiHmDq5M__"